// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.manual-link[data-v-6966fe32] {\n  color: #0d6efd;\n  text-decoration: underline;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
